import {
  commonPropertySuggest
} from "./chunk-26UMDPK3.js";
import {
  getConfigWithMetadata
} from "./chunk-NFLWKIRZ.js";
import {
  getErrorResult
} from "./chunk-IPNO7PON.js";

// src/services/getSuggestionsByDisplayId/getSuggestionsByDisplayId.ts
async function getSuggestionsByDisplayId(input, options, apiConfig) {
  try {
    const _apiConfig = getConfigWithMetadata(apiConfig, "getSuggestionsByDisplayId");
    const response = await commonPropertySuggest(
      {
        input,
        limit: options.limit,
        language: options.language
      },
      _apiConfig
    );
    return {
      status: "success",
      data: response
    };
  } catch (error) {
    apiConfig.onError?.(error);
    return getErrorResult(error);
  }
}

export {
  getSuggestionsByDisplayId
};
